import apiClient from '@src/services/apiClient'
import { submitMemberFormPath } from '@hkpca-web/config/apiPaths'

export const submitMemberForm = (formData) => {
  return apiClient.post(
    submitMemberFormPath,
    formData
  )
}
